module.exports = __webpack_public_path__ + "img/18.4.B.cc7231b6.png";